var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.4285,
    y1: 44.8022,
    x2: 86.5496,
    y2: 44.8022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7284FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#94DCF4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.73,17.99V45.7c0,4.79-3.89,8.68-8.68,8.68H34.28l-14.7,15.26l-0.83-15.26h-5.39 c-4.79,0-8.68-3.89-8.68-8.68V17.99c0-4.79,3.89-8.68,8.68-8.68h54.69C72.84,9.31,76.73,13.2,76.73,17.99z M24.43,65.03h32.44 L70.98,80.3l0.8-15.26h5.18c4.61,0,8.34-3.89,8.34-8.68V28.64c0-4.79-3.73-8.68-8.34-8.68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.7603,
    y1: 32.5543,
    x2: 64.4444,
    y2: 32.5543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7284FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#94DCF4"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.76,23.6h9.78V26h-7v4.69h6.41v2.39h-6.41v7.01h-2.78V23.6z M40.13,23.6l6.06,16.5H43.2l-1.38-3.98h-6.49 l-1.38,3.98h-2.98l6.07-16.5H40.13z M41.07,33.79l-2.49-7.18l-2.49,7.18H41.07z M55.65,23.32c4.95,0,8.77,3.72,8.77,8.53 c0,2.27-0.86,4.3-2.27,5.82l2.3,2.49l-1.83,1.64l-2.42-2.6c-1.31,0.75-2.86,1.19-4.55,1.19c-4.95,0-8.76-3.72-8.76-8.53 C46.9,27.04,50.7,23.32,55.65,23.32z M55.65,37.94c1.01,0,1.96-0.25,2.78-0.7l-2.56-2.79l1.83-1.64l2.6,2.85 c0.81-1.03,1.3-2.35,1.3-3.82c0-3.43-2.63-6.09-5.95-6.09c-3.32,0-5.94,2.66-5.94,6.09C49.71,35.29,52.33,37.94,55.65,37.94z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFaq);
export default __webpack_public_path__ + "static/media/icono_faq.2e5bee31ae644253aad9b52378f3ab2c.svg";
export { ForwardRef as ReactComponent };